import Reflux from 'reflux';

var ProfileActions = Reflux.createActions([
    'getProfile',
    'editProfile',
    'getMoreProfileTopics',
    'clearProfile'
]);

export default ProfileActions;



// WEBPACK FOOTER //
// ./src/actions/ProfileActions.js